<template>
  <div class="col-12">
    <div v-if="settings && settings.directBookings && settings.directBookings.enabled">
      <!-- <div class="panel-header panel-header-lg"></div> -->

      <div style="position: absolute; width: 100%;left: 0px;">
        <div class="row justify-content-center">
          <!-- <div style="width: 100%" class="text-center pl-5 pr-5">
            <img :src="backgroundImage" style="height: 18em; margin: auto; margin-bottom: 2em" />
          </div> -->

          <div class="col-lg-8 pl-5 pr-5">
            <cool-select class="custom-input" :placeholder="$t('message.Search doctor by name, speciality or condition')" :items="doctors" v-model="selectedDoctor" @search="searchDoctor" @keyup="coolSelectOnKeyUp" :resetSearchOnBlur="false" ref="doctorSearch">
              <template #no-data>
                {{""}}
              </template>
            </cool-select>
          </div>

          <!-- <div id="location-filterbar" v-if="settings && settings.directBookings.locationFiltering.enabled" class="col-lg-3 col-8 pl-5 pr-5">

            <div class="custom-input">
              <vue-google-autocomplete class="enter-location" ref="address" id="map" :placeholder="$t('message.Search Location')" v-on:placechanged="getAddressData" types="(cities)" v-on:focus="clearCurrentAddress" v-on:blur="setCurrentAddress">
              </vue-google-autocomplete>
            </div>

            <i class="fas fa-map-marker-alt" style="
              position: absolute;
              top: 0.6em;
              left: 3.5em;
              font-size: 1.2em;
              color: #fa6134;
            "></i>

            <i class="fas fa-chevron-down" style="
              position: absolute;
              top: 0.6em;
              inset-inline-end: 3.5em;
              font-size: 1.2em;
              color: rgb(250, 97, 52);
            "></i>
          </div> -->
          <span style="height: 75vh;overflow: scroll;">
            <div class="pl-5 pr-5" style="width: 100%;padding-top:0.5em;">
              <div class="row justify-content-center">
                <div v-if="doctorSearchQuery.length>2 && searchedDoctors.length==0" style="padding-top: 1.5em; margin-top: 2em;">
                  <p><i style="color: gray; padding-right: 0.5em;" class="fas fa-user-md"></i> {{$t('message.No doctors found')}} </p>
                </div>
                <div class="col-lg-4 pb-4" v-for="doctor in searchedDoctors" :key="doctor._id">
                  <doctor-card :doctor="doctor"></doctor-card>
                </div>

                <div class="col-12 pb-5" v-if="searchedDoctors && searchedDoctors.length > 0">
                  <n-pagination v-if="totalPages > 1" :page-count="totalPages" v-model="pageNumber"></n-pagination>
                </div>
              </div>
            </div>

            <div class="pl-5 pr-5 pb-5" :style="searchedDoctors.length < 1 ? { marginTop: '5em' } : {}" style="width: 100%">
              <div v-if="specialityGroups.length>0">
                <collapse :multiple-active="false">
                  <collapse-item :title="specialityGroup.name" name="1" v-for="specialityGroup in specialityGroups" :key="specialityGroup._id">
                    <speciality-group class="row" :specialityGroup="specialityGroup"></speciality-group>
                  </collapse-item>
                </collapse>
              </div>

              <div class="row" v-else>
                <div class="col-12">
                  <h2>{{ $t("message.Specialities") }}</h2>
                </div>
                <div class="col-12" v-for="speciality in specialities" :key="speciality._id" style="max-width: 30em;">
                  <card style="
                  height: 100px;
                  cursor: pointer;
                  border-radius: 5px;
                  overflow: hidden;
                " @click.native="selectSpeciality(speciality)">
                    <img v-if="!speciality.backgroundImage" src="@/assets/img/cardiology.jpg" style="
                    position: absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    filter: brightness(50%);
                    height: 100%;
                    width: 100%;
                  " />
                    <img v-if="speciality.backgroundImage" :src="
                    baseUrl +
                    '/directtelemedicine/file/speciality/' +
                    speciality._id
                  " style="
                    position: absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    filter: brightness(50%);
                    height: 100%;
                    width: 100%;
                  " />
                    <div class="row">
                      <div class="col-12 text-center">
                        <h6 class="card-title mt-3" style="color: #fff; font-size: larger">
                          {{ speciality.name }}
                        </h6>
                      </div>
                    </div>

                    <!-- <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller;">{{ doctor.specialityText || '--' }}</h6>
                <p class="card-text">{{ $t('message.waiting5') }}: {{ doctor.registration.number }}, {{ doctor.registration.city }}</p>-->
                    <p class="card-text">{{ speciality.description || "--" }}</p>
                    <!-- <a href="#" class="card-link" style="bottom: 0px;position: absolute;width: 100%">
                                    <n-button type="primary" round="">Book Appointment</n-button>
                </a>-->
                  </card>
                </div>

                <div class="col-12 pb-5" v-if="specialities && specialities.length > 0">
                  <n-pagination v-if="specialitiesPagination.totalPages > 1" :page-count="specialitiesPagination.totalPages" v-model="specialitiesPagination.pageNumber"></n-pagination>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="row" v-if="!settings || !settings.directBookings.enabled">
      <div class="col" style="text-align:center; margin-top: 5em;">
        <h5><i class="fas fa-info-circle"></i> Bookings is not enabled</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { CoolSelect } from "vue-cool-select";
// import VueGoogleAutocomplete from "vue-google-autocomplete";
import SpecialityGroup from "src/pages/carenation/components/SpecialityGroup.vue";

export default {
  name: "bookings",

  components: {
    SpecialityGroup,
    CoolSelect,
    // VueGoogleAutocomplete,
  },

  async mounted() {
    try {
      document.body.style.position = "relative";

      if (
        this.$route.query.focussearch &&
        this.$route.query.focussearch == "true"
      ) {
        this.$refs.doctorSearch.$el.getElementsByTagName("input")[0].focus();
      }
      // let domains = await this.$store.dispatch("getTenantDomains");

      // if (domains[window.location.hostname]) {
      //   this.$store.commit("setState", {
      //     stateName: "tenant",
      //     stateValue: domains[window.location.hostname].name,
      //   });
      // } else if (this.$route.params && this.$route.params.tenant) {
      //   this.$store.commit("setState", {
      //     stateName: "tenant",
      //     stateValue: this.$route.params.tenant,
      //   });
      // } else {
      //   this.$store.commit("setState", {
      //     stateName: "tenant",
      //     stateValue: "default",
      //   });
      // }

      // console.log("tenant", this.$store.state.tenant);

      // let urlParams = new URLSearchParams(window.location.search);
      // this.inpersonOnly = urlParams.get("inperson_only");
      // this.telemedOnly = urlParams.get("telemed_only");

      // let settings = await this.$store.dispatch("getPublicSettings");

      // if (settings) {
      //   this.$store.commit("setState", {
      //     stateName: "settings",
      //     stateValue: settings,
      //   });
      //   if (this.settings.homePageBackground) {
      //     this.backgroundImage =
      //       this.$store.state.baseUrl +
      //       "/directtelemedicine/download/" +
      //       this.settings.homePageBackground;
      //   }
      // }

      // try {
      //   await this.getSpecialityGroups();
      // } catch (e) {
      //   if (
      //     e.response &&
      //     e.response.data &&
      //     e.response.data.message &&
      //     e.response.data.message == "Tenant not found"
      //   ) {
      //     this.$router.push("/invalidurl");
      //   } else {
      //     swal.fire({
      //       type: "error",
      //       title: this.$t("message.Error"),
      //       text: this.$t("message.Contact Administrator"),
      //     });
      //   }
      // }

      try {
        this.getSpecialities();
      } catch (e) {
        if (
          e.response &&
          e.response.data &&
          e.response.data.message &&
          e.response.data.message == "Tenant not found"
        ) {
          this.$router.push("/invalidurl");
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Error"),
            text: this.$t("message.Contact Administrator"),
          });
        }
      }

      // if (this.settings.directBookings.locationFiltering.enabled) {
      //   this.getCurrentAddress();
      //   this.locationAccessAllowed = true;
      // }
    } catch (e) {
      console.log(e);
    }
  },

  beforeDestroy() {
    document.body.style.position = ""; // to fix gender select
  },

  data() {
    return {
      doctorSearchQuery: "",
      doctors: [],
      specialities: [],
      specialityGroups: [],
      searchedDoctors: [],
      selectedDoctor: null,
      pageNumber: 1,
      totalPages: 0,
      pageSize: 6,

      specialitiesPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 12,
      },
      specialityGroupsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 12,
      },
      inpersonOnly: false,
      telemedOnly: false,
      initialAddress: "",
      alertCardVisibility: false,
      locationAccessAllowed: false,
      // backgroundImage: require("@/assets/img/bg7.svg"),
    };
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },
    baseUrl() {
      return this.$store.state.baseUrl;
    },
    // geolocation() {
    //   return this.$store.state.geolocation;
    // },
  },

  methods: {
    async getAddressData(addressData, placeResultData, id) {
      let geolocation = {
        lat: await placeResultData.geometry.location.lat(),
        lng: await placeResultData.geometry.location.lng(),
      };
      this.$store.commit("setState", {
        stateName: "geolocation",
        stateValue: geolocation,
      });
    },
    async setCurrentAddress() {
      this.$refs.address.update(this.initialAddress);
    },
    async getCurrentAddress() {
      try {
        let pos = await this.getCurrentCoordinates();
        this.locationAccessAllowed = true;
        let geolocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        await this.$store.commit("setState", {
          stateName: "geolocation",
          stateValue: geolocation,
        });
        let geoResult = await this.$store.dispatch("getAddressFromGeoLoc");
        this.initialAddress = `${geoResult[0].name}, ${geoResult[0].countryCode}`;
        this.$refs.address.update(this.initialAddress);
      } catch (error) {
        if (error.code == 1) {
          this.locationAccessAllowed = false;
          console.log(this.locationAccessDenied);
          if (!document.querySelector("div.alert.open")) {
            this.$notify({
              icon: "fas fa-map-marker-alt",
              type: "primary",
              message: this.$t("message.Enable location access on the browser to find doctors near you"),
              horizontalAlign: "right",
              verticalAlign: "top",
              timeout: 900000,
              closeOnClick: false,
            });
          }
        } else {
          console.log(error);
        }
      }
    },
    clearCurrentAddress() {
      this.$refs.address.update("");
    },

    //called inside getCurrentAddress()
    getCurrentCoordinates() {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    },
    selectDoctor() {
      return [];
    },
    async searchDoctor(searchString) {
      this.searchedDoctors = [];
      let _this = this;

      this.doctorSearchQuery = searchString;
      let query = {
        searchString: searchString,
      };
      if (query.searchString.length > 2) {
        let response = await _this.$store.dispatch("searchDoctors", query);
        // {
        //   query: query,
        //   pageNumber: _this.pageNumber,
        //   pageSize: _this.pageSize,
        //   geolocation: _this.geolocation,
        // });
        if (this.doctorSearchQuery) {
          _this.searchedDoctors = response.data;
          _this.totalPages = response.totalPages;
        }
      } else {
        console.log("clearing doctors");
        this.searchedDoctors = [];
      }
    },
    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.doctorSearch.$el.querySelector("input").blur();
      }
    },

    //Specilities
    selectSpeciality(speciality) {
      this.$store.commit("setState", {
        stateName: "selectedSpeciality",
        stateValue: speciality,
      });
      this.$router.push("/speciality/" + speciality._id);
    },
    async getSpecialities() {
      let response = await this.$store.dispatch("getSpecialities", {
        pageNumber: this.specialitiesPagination.pageNumber,
        pageSize: this.specialitiesPagination.pageSize,
      });
      this.specialities = response.data;
      this.specialitiesPagination.totalPages = response.totalPages;

      console.log("specialities", this.specialities);
    },

    //speciality groups
    async getSpecialityGroups() {
      let response = await this.$store.dispatch("getSpecialityGroups", {
        pageNumber: this.specialityGroupsPagination.pageNumber,
        pageSize: this.specialityGroupsPagination.pageSize,
      });
      this.specialityGroups = response.data;
    },
  },

  watch: {
    pageNumber: function () {
      this.searchDoctor();
    },
    "specialitiesPagination.pageNumber": function () {
      this.getSpecialities();
    },
  },
};
</script>

<style>
.notifications .alert[data-notify="container"] {
  width: 40% !important;
  min-width: 340px;
}
img {
  border-radius: 0px;
}
.main-panel > .navbar {
  box-shadow: 1px 1px #21446b00;
}
.panel-header {
  overflow: visible;
}
.IZ-select__menu.IZ-select__menu--at-top,
.IZ-select__menu.IZ-select__menu--at-bottom {
  display: none;
}
.card-collapse .card .card-header {
  font-size: 2em;
}
</style>

<style scoped>
.custom-input.IZ-select {
  height: 4em;
}
.enter-location {
  height: 40px;
  padding-left: 2.5em;
  background-color: white;
  border-bottom-right-radius: 0;
  border-right-color: #00000069 !important;
  border-right-width: 2px !important;
  border-top-right-radius: 0;
}
/deep/.IZ-select__input > input {
  padding-left: 32%;
}

#location-filterbar {
  position: absolute;
  top: 20em;
  left: 15%;
}
@media screen and (max-width: 992px) {
  /deep/.IZ-select__input > input {
    padding-left: 18px;
  }
  #location-filterbar {
    top: 17em;
    left: -15px;
  }
  .enter-location {
    background-color: transparent;
    border: 0px !important;
    border-bottom-right-radius: 30px;
    border-top-right-radius: 30px;
    color: white !important;
    height: 35px;
  }
}
</style>
